module.exports = __webpack_public_path__ + "img/13_15.d1a1b088.png";